import { useState, useEffect } from "react";

/**
 * A custom hook to cycle through an array of items.
 * @param {Array} items The array of items to cycle through.
 * @returns {Object} The current item, navigation functions, and state.
 */
export const useCycle = (items = []) => {
  const [index, setIndex] = useState(0);

  // When the items array changes (e.g., an invite is accepted/declined),
  // reset the index to 0 to avoid being out of bounds.
  useEffect(() => {
    setIndex(0);
  }, [items]);

  const total = items.length;
  const currentItem = items[index];

  const next = () => {
    setIndex((prevIndex) => (prevIndex + 1) % total);
  };

  const prev = () => {
    setIndex((prevIndex) => (prevIndex - 1 + total) % total);
  };

  return {
    currentItem,
    next,
    prev,
    index,
    total,
    isMultiple: total > 1,
  };
};
